import JSZip from 'jszip';
import type { KostDataImportDatasetInputProcessorProgressEvent } from './input-processor-progress-event';

export class KostDataImportArchiveHelper {
  public static async unzip(
    zipFile: File,
    progressCallback: (
      event: KostDataImportDatasetInputProcessorProgressEvent,
    ) => void,
  ): Promise<{ errors: string[] } | { [key: string]: JSZip.JSZipObject }> {
    progressCallback({
      step: `Auslesen von ${zipFile.name}`,
      current: 0,
      max: 1,
      type: { name$: 'STEP_UPDATE' },
    });
    let result: { [key: string]: JSZip.JSZipObject } = {};

    try {
      const zipContent = await JSZip.loadAsync(zipFile);

      result = zipContent.files;
    } catch (e) {
      return { errors: [`${zipFile.name} ist kein gültiges ZIP Archiv.`] };
    }
    progressCallback({
      step: `Auslesen von ${zipFile.name} abgeschlossen`,
      current: 1,
      max: 1,
      type: { name$: 'STEP_UPDATE' },
    });

    return result;
  }

  public static async zip(
    archiveContent: File[],
    progressCallback: (
      event: KostDataImportDatasetInputProcessorProgressEvent,
    ) => void,
  ): Promise<Blob> {
    progressCallback({
      step: 'Erstelle ZIP-Datei mit verarbeiteten Daten',
      current: 0,
      max: 1,
      type: { name$: 'STEP_UPDATE' },
    });

    const zip = new JSZip();
    archiveContent.forEach((file) => {
      zip.file(file.name, file);
    });

    const archive: Blob = await zip.generateAsync({
      type: 'blob',
      compression: 'DEFLATE',
      compressionOptions: {
        level: 8,
      },
    });

    progressCallback({
      step: 'Erstellen der neuen ZIP-Datei abgeschlossen',
      current: 1,
      max: 1,
      type: { name$: 'STEP_UPDATE' },
    });

    return archive;
  }
}
